import Waveform from './Waveform'

export default Waveform



// WEBPACK FOOTER //
// ./src/legacy/components/Waveform/index.js